export const OWNERSHIP_SCOPES = Object.freeze({
  MINE: "mine",
  ALL: "all",
  ORG: "org",
});

export const DEFAULT_OWNERSHIP_SCOPE = OWNERSHIP_SCOPES.ALL;

export function normalizeOwnershipScope(value) {
  const normalized = String(value || "").trim().toLowerCase();
  if (normalized === OWNERSHIP_SCOPES.ORG) return OWNERSHIP_SCOPES.ALL;
  if (normalized === "team") return OWNERSHIP_SCOPES.ALL;
  if (normalized === OWNERSHIP_SCOPES.MINE) return OWNERSHIP_SCOPES.MINE;
  if (normalized === OWNERSHIP_SCOPES.ALL) return OWNERSHIP_SCOPES.ALL;
  return DEFAULT_OWNERSHIP_SCOPE;
}

export function shouldRestrictToTeam({ scope, isOrgOwner } = {}) {
  if (!isOrgOwner) return false;
  const normalized = normalizeOwnershipScope(scope);
  return (
    normalized === OWNERSHIP_SCOPES.ALL ||
    normalized === OWNERSHIP_SCOPES.MINE
  );
}

export function filterByOwnership(items, { scope, userId, ownerFields } = {}) {
  const list = Array.isArray(items) ? items : [];
  if (!userId) return list;
  if (normalizeOwnershipScope(scope) !== OWNERSHIP_SCOPES.MINE) return list;
  const fields =
    Array.isArray(ownerFields) && ownerFields.length > 0
      ? ownerFields
      : ["user_id"];

  const withVariants = Array.from(
    new Set(
      fields
        .flatMap((field) => {
          const key = String(field || "").trim();
          if (!key) return [];
          const snakeKey = key.replace(/[A-Z]/g, (char) => `_${char.toLowerCase()}`);
          const camelKey = key.replace(/_([a-z0-9])/g, (_, char) =>
            char.toUpperCase(),
          );
          return [key, snakeKey, camelKey];
        })
        .filter(Boolean),
    ),
  );

  return list.filter((item) =>
    withVariants.some((field) => {
      const value = item?.[field];
      return value === userId || String(value || "") === String(userId || "");
    }),
  );
}
